import { SVGAssets } from '@business/assets/vectors';
import { ContextMenuItem } from '@business/workflows/ComponentUI';
import { useState, useCallback } from 'react';
import { useTrashRestoreDelete } from './TrashRestoreDelete';

const contextMenuIconClassName = 'w-4 h-4 text-[#505050]';
const contextMenuIconClassNameRed = 'w-4 h-4 text-red-600';

export const useRecipeFolderTrashContextMenu = () => {
  const [selectedRecipeFolder, setSelectedRecipeFolder] = useState<any>(null);
  const [isDeleteRecipeFolderConfirm, setIsDeleteRecipeFolderConfirm] =
    useState<boolean>(false);
  const [restoreRecipeFolderId, setRestoreRecipeFolderId] =
    useState<string>('');
  const [isRecipeFolderRestoreConfirm, setIsRecipeFolderRestoreConfirm] =
    useState<boolean>(false);

  const { deleteFolder, restoreFolder } = useTrashRestoreDelete();

  const handleDeleteRecipeFolder = (
    folderId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    deleteFolder({
      module: 'recipes',
      folderId,
      onSuccess: () => {
        setSelectedRecipeFolder(null);
        setIsDeleteRecipeFolderConfirm(false);
        onSuccess?.();
      },
      onError
    });
  };

  const handleRestoreRecipeFolder = (
    folderId: string,
    onSuccess?: () => void,
    onError?: (error: any) => void
  ) => {
    restoreFolder({
      module: 'recipes',
      folderId,
      onSuccess: () => {
        setRestoreRecipeFolderId('');
        setIsRecipeFolderRestoreConfirm(false);
        onSuccess?.();
      },
      onError: err => {
        setIsRecipeFolderRestoreConfirm(false);
        onError?.(err);
      }
    });
  };

  const recipeFolderContextMenuItems = useCallback(
    (folder: any) => [
      {
        id: '1',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.ProfileEditIcon className={contextMenuIconClassName} />
            }
            label="Restore"
          />
        ),
        onClick: () => {
          setRestoreRecipeFolderId(folder?.id);
          setIsRecipeFolderRestoreConfirm(true);
        }
      },
      {
        id: '2',
        label: (
          <ContextMenuItem
            icon={
              <SVGAssets.TrashIcon className={contextMenuIconClassNameRed} />
            }
            label="Delete"
            labelClassName="text-red-600"
          />
        ),
        onClick: () => {
          setSelectedRecipeFolder(folder?.id);
          setIsDeleteRecipeFolderConfirm(true);
        }
      }
    ],
    []
  );

  return {
    recipeFolderContextMenuItems,
    selectedRecipeFolder,
    setSelectedRecipeFolder,
    isDeleteRecipeFolderConfirm,
    setIsDeleteRecipeFolderConfirm,
    restoreRecipeFolderId,
    setRestoreRecipeFolderId,
    isRecipeFolderRestoreConfirm,
    setIsRecipeFolderRestoreConfirm,
    handleDeleteRecipeFolder,
    handleRestoreRecipeFolder
  };
};
